module.exports = __webpack_public_path__ + "media/qh-cn.a4679e3c.mp3";